import axios from 'axios';

class SealService {
  async getSelos() {
    const { data } = await axios.get(`/v2/selos/website`);

    const mapped = [];

    if (data && Array.isArray(data.seal)) {
      data.seal.forEach(selo => {
        mapped[selo.position] = selo;
      });
    }

    return mapped;
  }
}

// Singleton
const instance = new SealService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/seals.js